import React, { Fragment, useState } from 'react';

import { Button } from 'antd';

import { makeVehiclePlate } from 'lib/helpers/Domain.helper';
import { Show } from 'lib/Show';
import { Guest } from 'types/Guest.type';

import { GuestVehicleDetailsModal } from '../GuestVehicleDetailsModal';

type Props = { vehicle: Guest.Vehicle.Model };

export function GuestVehicleCell({ vehicle }: Props) {
    const [isDetailsModalVisible, setIsDetailsModalVisible] = useState(false);

    const label = `${vehicle.brand} (${vehicle.model}) - ${makeVehiclePlate(vehicle.plate)}`;

    return (
        <Fragment>
            <Button
                type="link"
                style={{ '--ant-button-padding-inline': 0 }}
                onClick={() => setIsDetailsModalVisible(true)}
            >
                {label}
            </Button>

            <Show when={isDetailsModalVisible}>
                <GuestVehicleDetailsModal
                    vehicle={vehicle}
                    onCancel={() => setIsDetailsModalVisible(false)}
                />
            </Show>
        </Fragment>

    );
}
